import React, { useCallback, useState } from 'react';
import { useIntl } from 'react-intl';

import Grid from '@mui/material/Grid2';
import { useTheme } from '@mui/styles';
import Radio from '@mui/material/Radio';
import Button from '@mui/material/Button';
import RadioGroup from '@mui/material/RadioGroup';
import LoadingButton from '@mui/lab/LoadingButton';
import FormControlLabel from '@mui/material/FormControlLabel';

import ConfirmModal from 'src/components/ConfirmModal';
import { useGetAcceptReason } from 'src/pages/ProjectDetailsPage/api';

import messages from './messages';

export default function AcceptReasonModal({
  type,
  modalLabel,
  buttonLabel,
  bulkButtonLabel,
  disabledButton,
  enabledFetch,
  isLoading,
  onConfirm,
  disabledBulkButton,
  open,
  onClose,
}: UCM.AcceptRejectModalType) {
  const theme = useTheme();
  const { formatMessage } = useIntl();

  const [reason, setReason] = useState('');
  const [bulkAction, setBulkAction] = useState(false);

  const { data: acceptReason } = useGetAcceptReason(
    { reason_for: type },
    { enabled: enabledFetch },
  );

  const handleSubmit = useCallback(async () => {
    return onConfirm(reason, bulkAction);
  }, [onConfirm, reason, bulkAction]);

  const handleOpenModal = useCallback(
    (
      handleOpen: (event: React.MouseEvent<HTMLElement>) => void,
      isBulk: boolean,
    ) =>
      (event: React.MouseEvent<HTMLElement>) => {
        setBulkAction(isBulk);
        handleOpen(event);
      },
    [],
  );

  const handleChange = useCallback(
    (event: React.ChangeEvent<HTMLInputElement>) => {
      setReason(event.target.value);
    },
    [],
  );

  return (
    <ConfirmModal
      disabled={!reason}
      onConfirm={handleSubmit}
      open={open}
      onClose={onClose}
      width={theme.spacing(69)}
      submitTextButton={formatMessage(messages.confirmButtonLabel)}
      title={modalLabel ?? ''}
      triggerButton={(handleOpen) => {
        return (
          <>
            {buttonLabel && (
              <LoadingButton
                loading={isLoading}
                variant="contained"
                disabled={disabledButton}
                onClick={handleOpenModal(handleOpen, false)}
              >
                {buttonLabel}
              </LoadingButton>
            )}

            {bulkButtonLabel && (
              <Button
                variant="outlined"
                disabled={disabledBulkButton}
                onClick={handleOpenModal(handleOpen, true)}
              >
                {bulkButtonLabel}
              </Button>
            )}
          </>
        );
      }}
    >
      <Grid p={1.5}>
        <RadioGroup
          defaultValue=""
          name="radio-buttons-group"
          onChange={handleChange}
        >
          {acceptReason?.map((item) => {
            return (
              <FormControlLabel
                key={item.code}
                value={item.code}
                control={<Radio />}
                label={item.title}
              />
            );
          })}
        </RadioGroup>
      </Grid>
    </ConfirmModal>
  );
}
